import {Component, EventEmitter} from "@angular/core";
import {FUIModalsService} from "@fedelta-pos/ui";

export enum SignUpAction {
    CANCEL,
    SIGN_UP_PERSON,
    SEND_SIGN_UP,
    SIGN_UP_LATER
}

@Component({
    selector: "fhm-sign-modal",
    templateUrl: "./signup-modal.component.html",
    styleUrls: ["signup-modal.component.scss"],
    standalone: false
})
export class SignupModalComponent {

    state: boolean = true;

    onConfirm: EventEmitter<SignUpAction> = new EventEmitter<SignUpAction>();

    constructor(private modalsService: FUIModalsService) {
    }

    cancel(): void {
        this.onConfirm.emit(SignUpAction.CANCEL);
        this.modalsService.close(this);
    }

    signUpInPerson(): void {
        this.onConfirm.emit(SignUpAction.SIGN_UP_PERSON);
    }

    sendSignUpUrl(): void {
        this.onConfirm.emit(SignUpAction.SEND_SIGN_UP);
    }

    signUpLater(): void {
        this.onConfirm.emit(SignUpAction.SIGN_UP_LATER);
    }

}
